import React from 'react';
import clsx from 'clsx';
import MuiFormControlLabel, { FormControlLabelProps } from '@material-ui/core/FormControlLabel';
import Paper, { PaperProps as MuiPaperProps } from '@material-ui/core/Paper';
import capitalize from '@material-ui/core/utils/capitalize';

import useStyles from './style';

export interface FormControlPaperProps extends FormControlLabelProps {
    PaperProps: MuiPaperProps;
    /**
     * The color of the component. It supports those theme colors that make sense for this component.
     * @default 'primary'
     */
    color?: 'primary' | 'secondary' | 'default' | 'inherit';
    /**
     * The variant to use.
     * @default 'outlined'
     */
    variant?: 'outlined';
}

const FormControlPaper: React.FC<FormControlPaperProps> = (props: FormControlPaperProps) => {
    const { className, color, disabled, variant, PaperProps, ...other } = props;
    const classes = useStyles();
    const classNameMerged = clsx(
        {
            [classes.root]: true,
            [classes[`${variant}${capitalize(color)}`]]: color !== 'inherit',
            [classes.disabled]: disabled,
        },
        className,
    );

    return (
        <Paper className={classNameMerged} {...PaperProps}>
            <MuiFormControlLabel {...other} />
        </Paper>
    );
};

FormControlPaper.defaultProps = {
    color: 'default',
    variant: 'outlined',
};

export default FormControlPaper;
